import MetaTags from "react-meta-tags";

import { useMediaQuery } from "customHooks/useMediaQuery";

import starIcon from "assets/icons/svg/AboutUsIcons/star.svg";
import cameraIcon from "assets/icons/svg/AboutUsIcons/camera.svg";
import cycleIcon from "assets/icons/svg/AboutUsIcons/cycle.svg";
import curlsIcon from "assets/icons/svg/AboutUsIcons/curls.svg";

import "./style.scss";

export const AboutUsStory = () => {
	const width = useMediaQuery();
	const isMobile = width < 900 ? true : false;

	const title = {
		top: "OUR STORY",
		bottom: "Who are we?",
	};

	// const story =
	// 	"Our fondest memory of vacation with our family is travelling through Europe with our toddlers in tow: having the freedom to experience stunning locations in quaint homestays, no one judging us for cooking khichdi for our two raucous children while we gorged on local delicacies ourselves, and always being showered with impeccable hospitality in every home. We were the quintessential Indian families exploring the world, wanting the certainty of safety and quality, and the privacy to enjoy our holiday on our own terms. This holiday changed our lives forever. It gave birth to SaffronStays.";
	// const story2 =
	// 	" Rank outsiders to the hospitality industry, we decided to address the dearth of curated experiences back home. We unlocked the gates of otherwise inaccessible private vacation homes to families looking for holidays that extended beyond checklists of must-sees and must-dos. Today we service the needs of both, Home Owners and Guests. Owners who have gorgeous homes that need to be maintained and, guests who are looking for the reliability of hotel services in the luxury of a private serviced home; often a short getaway that fits into a busy schedule. We have, and always will provide unforgettable private spaces for friends, families and colleagues to bond and create memories in. We discover and unlock only the best private homes so that guests may never tire from decision fatigue and yet can take short getaways despite their busy schedules.";

	// const story = (
	// 	<>
	// 		<p>
	// 			Plans toh itne bante hai, but plans with your loved ones are too
	// 			precious to risk. At SaffronStays, we believe vacations are about
	// 			togetherness and bonding, in your own private space, away from maddening
	// 			crowds.
	// 		</p>
	// 		{/* <br /> */}
	// 		<p>A place…</p>
	// 		<p>Where you celebrate the highlights of your life;</p>
	// 		<p>Where enjoying the pool means having one all to yourself;</p>
	// 		<p>Where fresh, home-cooked meals are served with style and love;</p>
	// 		<p>
	// 			Where spending time with your loved ones means more than just meeting
	// 			them in a lobby;
	// 		</p>
	// 		<p>
	// 			Where no family members, whether colleagues or four-legged ones, get
	// 			left behind.
	// 		</p>
	// 		{/* <br /> */}
	// 		<p>
	// 			We go to extreme lengths, to handpick India’s hidden gems, away from the
	// 			chaos of city life, to find villas, homestays, and estates, with
	// 			breath-taking views, gorgeous aesthetics and the right home-like vibe,
	// 			all within driving distance from your city.
	// 		</p>
	// 		{/* <br /> */}
	// 		<p>
	// 			We are challenging and redefining the very concept of luxury in
	// 			hospitality; shifting the narrative from chandeliers, chocolates and
	// 			caviar to privacy, panoramas and patios.
	// 		</p>
	// 		{/* <br /> */}
	// 		<p>
	// 			So, who are we? A hospitality startup born out of a deep desire of our
	// 			Founders - Tejas and Deven - to curate a home away from home, where we
	// 			marry the comforts of a luxury hotel, to the privacy and warmth of a
	// 			Home.
	// 		</p>
	// 		{/* <br /> */}
	// 		<p>Looking forward to hosting you soon!</p>
	// 		{/* <br /> */}
	// 		<p className="founders">Tejas and Deven Parulekar,</p>
	// 		<p>Founders, SaffronStays</p>
	// 	</>
	// );
	// const story_footer = "Tejas & Deven, Founders";

	return (
		<>
			<MetaTags>
				<title>
					300+ Villas & Estates. Managed, Serviced and Unlocked by SaffronStays
				</title>
				<meta
					name="description"
					content="300+ Villas & Estates.  Managed, Serviced and Unlocked by SaffronStays"
				/>
			</MetaTags>

			<div className="about_us_story_wrapper">
				<div className="AboutUsHeading">
					<div className="top">{title.top}</div>
					<div className="bottomf">
						Family,{" "}
						<span
							style={{
								color: "rgb(251,169,25)",
								fontFamily: "inherit",
							}}
						>
							matlab
						</span>{" "}
						SaffronStays!
					</div>
				</div>
				<div className="story_body">
					{/* <div>{story}</div> */}
					<div dir="ltr">
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							{/* <br /> */}
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Plans toh itne bante hai, but plans with your loved ones are too
							precious to risk. At SaffronStays, we believe holidays are about
							togetherness and bonding, in your own private space, away from
							maddening crowds.
						</p>
						<br
							style={{
								fontFamily: "inter,sans-serif",
								fontSize: 14,

								margin: 0,
								padding: 0,
							}}
						/>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							A place…
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Where you celebrate the highlights of your life;
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Where enjoying the pool means having one all to yourself;
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Where fresh, home-cooked meals are served with style and love;
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Where spending time with your loved ones means more than just
							meeting them in a lobby;
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Where no family members, whether colleagues or four-legged ones,
							get left behind.
						</p>
						<br
							style={{
								fontFamily: "inter,sans-serif",
								fontSize: 14,

								margin: 0,
								padding: 0,
							}}
						/>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							We go to extreme lengths, to handpick India’s hidden gems, away
							from the chaos of city life, to find villas, homestays, and
							estates, with breath-taking views, gorgeous aesthetics and the
							right home-like vibe, all within driving distance from your city.
						</p>
						<br
							style={{
								fontFamily: "inter,sans-serif",
								fontSize: 14,

								margin: 0,
								padding: 0,
							}}
						/>
						<p
							dir="auto"
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							We are challenging and redefining the very concept of luxury in
							hospitality; shifting the narrative from luxury being narrowly
							defined by chandeliers, chocolates and caviar, to being defined by
							precious time spent with family and friends.&nbsp;&nbsp;
						</p>
						<br
							style={{
								fontFamily: "inter,sans-serif",
								fontSize: 14,

								margin: 0,
								padding: 0,
							}}
						/>
						<p
							dir="auto"
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							So, who are we? A hospitality startup born out of our deepest
							desire to curate a home away from home, where we marry the
							comforts of a luxury hotel, to the privacy and warmth of a
							Home…for you to whisk away your “framilies” for an unforgettable
							getaway.&nbsp;&nbsp;
						</p>
						<br
							style={{
								fontFamily: "inter,sans-serif",
								fontSize: 14,

								margin: 0,
								padding: 0,
							}}
						/>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Looking forward to hosting you soon!
						</p>
						<br
							style={{
								fontFamily: "inter,sans-serif",
								fontSize: 14,

								margin: 0,
								padding: 0,
							}}
						/>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 20,
								fontWeight: 700,
							}}
						>
							Tejas and Deven Parulekar,
						</p>
						<p
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Founders, SaffronStays
						</p>
						<p
							dir="auto"
							style={{
								fontFamily: "inter,sans-serif",

								margin: "0.5rem 0px 0px",
								padding: 0,
								lineHeight: "1.5",
								fontSize: 16,
							}}
						>
							Where Families Bond
						</p>
					</div>

					{/* <div className="bottom_para">
					{story2}
					{isMobile && (
						<img className="camera_icon2" src={cameraIcon} alt="camera_icon2" />
					)}
					{isMobile && (
						<img className="star_icon3" src={starIcon} alt="camera_icon2" />
					)}
				</div> */}
				</div>
				{/* <div className="story_footer">
				<div className="footer_line">
					<hr className="footer_line_hr" />
				</div>
				{story_footer}
			</div> */}
				<img className="star_icon" src={starIcon} alt="star_icon" />

				<img className="curls_icon" src={curlsIcon} alt="curls_icon" />
				{!isMobile && (
					<img className="camera_icon" src={cameraIcon} alt="camera_icon" />
				)}
				{!isMobile && (
					<img className="star_icon2" src={starIcon} alt="star_icon2" />
				)}
				<img className="cycle_icon" src={cycleIcon} alt="cycle_icon" />
			</div>
		</>
	);
};
